import { parseISO } from 'date-fns';

import { RTopic, Topic } from '@dh/types';

export const mapTopic = (topic: RTopic): Topic => {
    const { id, documentId, title_de, ...timeStampAttributes } = topic;
    const { createdAt, updatedAt, publishedAt } = timeStampAttributes;

    return {
        id,
        documentId,
        createdAt: parseISO(createdAt),
        updatedAt: parseISO(updatedAt),
        publishedAt: publishedAt ? parseISO(publishedAt) : null,
        title: title_de,
        parent: topic.cluster && {
            id: topic.cluster.id,
            documentId: topic.cluster.documentId,
            title: topic.cluster.title_de,
            description: topic.cluster.description_de
        },
        isDoubledScored: undefined
    };
};

const byTitle = (a: Topic, b: Topic) => a.title.localeCompare(b.title);

export const mapTopics = (topics?: RTopic[] | null) =>
    topics ? topics.map(mapTopic).sort(byTitle) : [];

export const mapMatchTopics = ({
    topics,
    doubledTopics
}: {
    topics?: RTopic[] | null;
    doubledTopics?: RTopic[] | null;
}) =>
    mapTopics(topics).map((t) => {
        if (doubledTopics?.find((dt) => dt.documentId === t.documentId)) {
            return { ...t, isDoubledScored: true };
        }
        return t;
    });
